export function setActividades(state, actividades) {
    
    state.actividades = actividades;
    
}




export function actListActividades(state, actividad) {
    if (actividad !== null) {
        const index = state.actividades.findIndex(r => r.id === actividad.id)
        if (index != -1) {
            state.actividades.splice(index, 1, actividad)   
        }
    }
  
}

export function actDeleteListActividades(state, id) {
   
    if (id != null) {
        const index = state.actividades.findIndex(r => r.id === id)
        if (index != -1) {
            state.actividades.splice(index, 1)
        }
    }
}



export function setActividadSelec(state, actividad) {
    state.actividadSelec = actividad
}




